import { defineStyleConfig } from "@chakra-ui/react";

const KPICards = defineStyleConfig({
  baseStyle: () => {
    return {};
  },
});

export default KPICards;
